<template>
    <div style="min-height: 80vh;">
        <div class="container">
            <!-- 左侧导航 -->
            <div class="left-nav">
                <!-- 导航项：我的竞标 -->
                <!-- <div @click="handleSwitch(1)" :class="cli == 1 ? 'active' : ''" class="nav-item ">
                    我的竞标
                </div> -->
                <!-- 导航项：企业信息 -->
                <div @click="handleSwitch(2)" :class="cli == 2 ? 'active' : ''" class="nav-item">
                    请选择所属业务部门
                </div>

                <!-- 企业信息下的业务中心子列表（折叠动画） -->
                <el-collapse-transition>
                    <div v-show="cli == 2">
                        <!-- 遍历业务中心列表 -->
                        <div @click="handleQyxx(item.ID)" v-for="item in department_list" :key="item.ID"
                            :class="item.ID == is_department ? 'is_item' : ''" class="nav-item active3">
                            <span>
                                {{ item.TITLE }}
                            </span>
                        </div>
                    </div>
                </el-collapse-transition>
                <div @click="handleSwitch(3)" :class="cli == 3 ? 'active' : ''" class="nav-item">
                    缴纳保证金
                </div>
            </div>



            <!-- 条件渲染：如果正在查看企业信息 -->
            <template v-if="is_information == 2">
                <div class="content">
                    <Loading :loading="loading" color="#c31424" background="rgba(0, 0, 0, 0.3)" />

                    <div v-if="status_ == 2" class="status">
                        <div class="status_box ">
                            审核结果
                            <img style="width: 60px;height: 60px;margin-left: 10px;" src="@/assets/shenhe0.png" alt="">
                        </div>
                        <span
                            style="flex-direction: column;color: #C31424;background-color: #FFF5F6;width: 100%;height: 94px;"
                            class=" status_test ">
                            审核未通过原因：
                            <span style="font-size: 12px;color: #666;">
                                {{ status_content }}
                            </span>
                        </span>
                    </div>
                    <div v-if="status_ == 0" class="status">
                        <div class="status_box">
                            审核结果
                            <img style="width: 60px;height: 60px;margin-left: 10px;" src="@/assets/shenhe1.png" alt="">
                        </div>
                        <span style="flex-direction: column;color: #FFA100;background-color: #fffbf4;"
                            class="status_test center_box">
                            审核中请耐心等待
                        </span>
                    </div>
                    <div v-if="status_ == 1" class="status">
                        <div class="status_box">
                            审核结果
                            <img style="width: 60px;height: 60px;margin-left: 10px;" src="@/assets/shenhe2.png" alt="">
                        </div>
                        <span class="status_box status_test center_box">
                            恭喜, 审核通过!
                        </span>
                    </div>
                    <!-- 企业信息表单 -->
                    <el-form :label-position="'left'" :rules="rules" label-width="auto" style="width: 100%;" ref="form"
                        :model="form_all">
                        <!-- 条件渲染：表单数据加载后显示 -->
                        <div class="container_B" v-if="true">
                            <!-- 遍历 dataJson 生成表单区域 (排除 SHOP_RZ 表) -->
                            <div v-for="item, index in dataJson" v-if="item.TABLE_NAME != 'SHOP_RZ'" class="container_"
                                :key="item.ID">
                                <!-- 表单区域标题 -->
                                <div class="title">
                                    <span class="left_text">{{ item.TITLE }}</span>
                                </div>
                                <!-- 表单项容器 -->
                                <div class="footerContent">
                                    <!-- 遍历当前区域的表单项 -->
                                    <el-form-item class="el_item" :prop="`formData1.${index}.${ever.COLUMN_NAME}`"
                                        :rules="ever.IS_RULES == 1 ? [{ required: true, message: `请输入${ever.NAME}`, trigger: 'blur' }] : []"
                                        v-for="ever in item.lists" :key="ever.ID" :label="ever.NAME">

                                        <!-- 输入框 (样式 1 或 5) -->
                                        <template v-if="ever.COLUMN_STYLE == 1 || ever.COLUMN_STYLE == 5">
                                            <el-input style="width: 100%;" class="input_style" :placeholder="ever.NAME"
                                                v-model="form_all.formData1[index][ever.COLUMN_NAME]"></el-input>
                                        </template>

                                        <!-- 日期选择器 (样式 2) -->
                                        <template v-if="ever.COLUMN_STYLE == 2">
                                            <el-date-picker style="width: 100%;" format="yyyy-MM-dd"
                                                value-format="yyyy-MM-dd" class="input_style"
                                                v-model="form_all.formData1[index][ever.COLUMN_NAME]" type="date"
                                                :placeholder="'请选择' + ever.NAME">
                                            </el-date-picker>
                                        </template>

                                        <!-- 表格输入 (样式 6) - 年份/员工/收入/利润 -->
                                        <template v-if="ever.COLUMN_STYLE == 6">
                                            <!-- 注意：这里的 v-model="form.data" 和 props 使用的是父组件的 form.data，可能需要调整为 form_all 或特定结构 -->
                                            <el-table :data="form.data" border style="width: 100%">
                                                <!-- 年份列 -->
                                                <el-table-column prop="address" label="年份" align="center">
                                                    <template #default="scope">
                                                        <el-form-item class="form_item"
                                                            :prop="`data.${scope.$index}.years`"
                                                            :rules="[{ required: true, message: '请输入年份', trigger: 'blur' }]">
                                                            <el-input v-model="form.data[scope.$index].years"
                                                                placeholder="请输入"></el-input>
                                                        </el-form-item>
                                                    </template>
                                                </el-table-column>
                                                <!-- 员工总数列 -->
                                                <el-table-column prop="ygzs" label="员工总数(人)" align="center">
                                                    <template #default="scope">
                                                        <el-form-item class="form_item"
                                                            :prop="`data.${scope.$index}.ygzs`"
                                                            :rules="[{ required: true, message: '请输入员工总数(人)', trigger: 'blur' }]">
                                                            <el-input v-model="form.data[scope.$index].ygzs"
                                                                placeholder="请输入"></el-input>
                                                        </el-form-item>
                                                    </template>
                                                </el-table-column>
                                                <!-- 销售收入列 -->
                                                <el-table-column prop="xssr" label="销售收入(万元)" align="center">
                                                    <template #default="scope">
                                                        <el-form-item class="form_item"
                                                            :prop="`data.${scope.$index}.xssr`"
                                                            :rules="[{ required: true, message: '请输入销售收入(万元)', trigger: 'blur' }]">
                                                            <el-input v-model="form.data[scope.$index].xssr"
                                                                placeholder="请输入"></el-input>
                                                        </el-form-item>
                                                    </template>
                                                </el-table-column>
                                                <!-- 年度净利润列 -->
                                                <el-table-column prop="ndlr" label="年度净利润(万元)" align="center">
                                                    <template #default="scope">
                                                        <el-form-item class="form_item"
                                                            :prop="`data.${scope.$index}.ndlr`"
                                                            :rules="[{ required: true, message: '请输入年度净利润(万元)', trigger: 'blur' }]">
                                                            <el-input v-model="form.data[scope.$index].ndlr"
                                                                placeholder="请输入"></el-input>
                                                        </el-form-item>
                                                    </template>
                                                </el-table-column>
                                                <!-- 操作列：删除按钮 -->
                                                <el-table-column label="操作" align="center" width="80">
                                                    <template #default="scope">
                                                        <!-- 根据 computed 属性判断是否禁用删除按钮 -->
                                                        <el-button :disabled="handle_is_del(scope.$index)" type="danger"
                                                            icon="el-icon-delete" size="mini"
                                                            @click="deleteRow1(scope.$index)"></el-button>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                            <!-- 添加行按钮 -->
                                            <el-button style="width: fit-content;margin-top: 10px;" type="danger"
                                                size="mini" @click="addRow1()">继续添加</el-button>
                                        </template>

                                        <!-- 复选框组 (样式 4) -->
                                        <template
                                            v-if="ever.COLUMN_STYLE == 4 && form_all.formData1[index] && ever.COLUMN_NAME">

                                            <div>
                                                <el-checkbox-group
                                                    v-model="form_all.formData1[index][ever.COLUMN_NAME]">
                                                    <!-- 检查模型值是否是数组，以避免渲染错误 -->
                                                    <template
                                                        v-if="form_all.formData1[index][ever.COLUMN_NAME] instanceof Array">
                                                        <el-checkbox v-for="e, idx in handleTransition(ever.CONTENTS)"
                                                            :key="idx" :label="e"></el-checkbox>
                                                    </template>
                                                </el-checkbox-group>
                                            </div>
                                            <!-- '其他'选项的备注输入框 (逻辑可能需要调整，原formData.value已移除) -->
                                            <!-- <div v-if="form_all.formData1[index][ever.COLUMN_NAME]?.includes('其他(请备注)')">
                                            <el-input class="input_style" placeholder="请备注" v-model="form_all.formData1[index][ever.COLUMN_NAME + '_remark']"></el-input>
                                            </div> -->
                                        </template>

                                        <!-- 文件/图片上传 (样式 7) -->
                                        <template
                                            v-if="ever.COLUMN_STYLE == 7 && form_all.formData1[index] && ever.COLUMN_NAME">
                                            <div style="display: flex;">
                                                <!-- 图片预览 -->
                                                <div class="handle_image_l"
                                                    v-for="imgItem, imgIndex in handle_image_l(form_all.formData1[index][ever.COLUMN_NAME])"
                                                    :key="imgIndex">
                                                    <img style="width: 60px;height: 60px;"
                                                        :src="'https://xunjiah.mkaka.icu' + imgItem" alt="图片预览">
                                                </div>
                                                <!-- 上传组件 -->
                                                <my-upload :limit="5" :auto-upload="true"
                                                    @change="handleFileChange(index, ever.COLUMN_NAME)"
                                                    @success="handleUploadSuccess" @error="handleUploadError" />
                                            </div>
                                        </template>

                                    </el-form-item>
                                </div>
                            </div>

                            <!-- 遍历 dataJson 生成表单区域 (仅 SHOP_RZ 表，资质上传) -->
                            <div v-for="item, index in dataJson" v-if="item.TABLE_NAME == 'SHOP_RZ'"
                                :key="'rz-' + item.ID">
                                <div class="title">
                                    <span class="left_text">{{ item.TITLE }}</span>
                                </div>
                                <div class="footerContent">
                                    <!-- 遍历 SHOP_RZ 的表单项 -->
                                    <el-form-item class="el_item" :prop="`upload_datas.${0}.${ever.COLUMN_NAME}`"
                                        :rules="[{ required: true, message: `请上传${ever.NAME}`, trigger: 'blur' }]"
                                        v-for="ever in item.lists" :key="ever.ID" :label="ever.NAME">
                                        <!-- 资质文件上传 (样式 7) -->
                                        <template
                                            v-if="ever.COLUMN_STYLE == 7 && form_all.upload_datas[0] && ever.COLUMN_NAME">
                                            <div style="display: flex;">
                                                <!-- 图片预览 -->
                                                <div class="handle_image_l"
                                                    v-for="imgItem, imgIndex in handle_image_l(form_all.upload_datas[0][ever.COLUMN_NAME])"
                                                    :key="imgIndex">
                                                    <img style="width: 60px;height: 60px;"
                                                        :src="'https://xunjiah.mkaka.icu' + imgItem" alt="资质预览">
                                                </div>
                                                <!-- 上传组件 -->
                                                <!-- 注意: 这里 handleFileChange 的第一个参数写的是 index，但 SHOP_RZ 数据结构在 form_all.upload_datas[0] 中，可能需要调整 -->
                                                <my-upload :limit="5" :auto-upload="true"
                                                    @change="handleFileChange(0, ever.COLUMN_NAME)"
                                                    @success="handleUploadSuccess" @error="handleUploadError" />
                                            </div>
                                        </template>

                                    </el-form-item>
                                </div>
                            </div>

                            <!-- 已移除资质信息列表 (原 v-if="false" 部分) -->

                        </div>
                        <!-- 保存按钮 -->
                        <!-- <el-button v-if="status_ == -1 || status_ == 2" @click="submitForm" -->

                    </el-form>

                    <!-- 企业信息表单 -->
                    <el-form v-if="true" :label-position="'left'" :rules="rules" label-width="250px"
                        style="width: 100%;" ref="form1" :model="form_all">
                        <!-- 条件渲染：表单数据加载后显示 -->
                        <div v-if="true">

                            <!-- 遍历 dataJson 生成表单区域 (仅 SHOP_RZ 表，资质上传) -->
                            <div>
                                <div class="title">
                                    <span class="left_text">资质信息</span>
                                </div>
                                <div class="footerContent">
                                    <!-- 遍历 SHOP_RZ 的表单项 -->
                                    <el-form-item v-for="(item, index) in form_all.upload_info_list"
                                        :key="'rz-' + item.ID" class="el_item" :prop="`upload_info_list.${index}.VALUE`"
                                        :rules="item.IS_RULES == 1 ? [{ required: true, message: `请上传${item.TITLE}`, trigger: 'blur' }] : []"
                                        :label="item.TITLE">
                                        <div style="display: flex;justify-content: space-between;">
                                            <!-- 显示已上传文件 -->
                                            <div
                                                style="display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 10px;">
                                                <el-tag class="xiao_shou" v-if="file.NAME"
                                                    v-for="(file, fileIndex) in item.VALUE" :key="file.ID"
                                                    type="success" :closable="status_ == -1 || status_ == 2"
                                                    @click="download(file.FILEPATH)"
                                                    @close="handleRemoveFile(index, fileIndex)">
                                                    {{ file.NAME }}
                                                </el-tag>
                                            </div>

                                            <!-- 上传组件 -->
                                            <my-upload up_load="/api/user/upload" v-if="status_ == -1 || status_ == 2"
                                                :limit="100" :auto-upload="true" :file-list="item.VALUE"
                                                @change="handleFileChange_upload_info(index)"
                                                @success="handleUploadSuccess_upload_info" @error="handleUploadError" />
                                        </div>
                                        <!-- 提示信息 -->
                                        <div class="upload-tips" @click="handle_cli(item)" v-if="item.CONTENTS">{{
                                            item.CONTENTS }} <a target="_blank" :href="item.WEBURL">{{
                                                item.WEBURL }}</a>

                                            <span v-for="ever, index in item.DOCS_ARR" :key="index">
                                                {{ ever.FILE_NAME }}
                                                <el-button @click="download(ever.FILE)" size="mini"
                                                    type="primary">下载</el-button>
                                            </span>
                                        </div>
                                    </el-form-item>
                                </div>
                            </div>

                            <!-- 已移除资质信息列表 (原 v-if="false" 部分) -->

                        </div>
                        <div style="height: 10px;"></div>
                        <!-- 保存按钮 -->
                        <el-button plain v-if="status_ == 0 || status_ == -1 || status_ == 2" @click="submitForm(1)"
                            type="primary">暂存</el-button>
                        <el-button v-if="status_ == 0 || status_ == -1 || status_ == 2" @click="submitForm(2)"
                            type="primary">提交</el-button>
                    </el-form>



                </div>

            </template>
            <template v-if="is_information == 3">
                <div class="content">

                    <div class="dialog_content">
                        <!-- 公司名称 -->
                        <div class="title_">
                            {{ userInfo.COMPANY_NAME }}
                        </div>
                        <!-- 保证金信息 -->
                        <!-- <div class="money_box">
            <div class="item_price">
              保证金:
              <span style="color: #c31424;">{{ userInfo.TOTAL_MONEY || 0 }}</span>
            </div>
            <div class="item_price">
              冻结保证金:
              <span style="color: #c31424;">{{ userInfo.FREEZE_MONEY || 0 }}</span>
            </div>
            <div class="item_price">
              可用保证金:
              <span style="color: #c31424;">{{ userInfo.USABLE_MONEY || 0 }}</span>
            </div>
          </div> -->

                        <!-- 缴纳保证金表单 -->
                        <el-form :model="price_form" :rules="rules9" ref="ruleForm" label-width="100px"
                            class="demo-ruleForm">
                            <!-- 所属业务中心 -->
                            <el-form-item label-width="150" label="所属业务中心" prop="DEPID">
                                <el-select v-model="price_form.DEPID" placeholder="请选择缴纳所属业务中心">
                                    <el-option v-for="item in department_list" :key="item.ID" :label="item.TITLE"
                                        :value="item.ID">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <!-- 缴纳时间 -->
                            <el-form-item label="缴纳时间" prop="JNDJ_TIME">
                                <el-date-picker v-model="price_form.JNDJ_TIME" format="yyyy-MM-dd" type="date"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <!-- 缴纳金额 -->
                            <el-form-item label="缴纳金额" prop="MONEY">
                                <el-input type="number" v-model="price_form.MONEY"></el-input>
                            </el-form-item>
                            <!-- 缴纳凭证 -->
                            <el-form-item label="缴纳金凭证" prop="IMAGE">
                                <div style="display: flex;">
                                    <!-- 凭证图片预览 -->
                                    <img v-if="price_form.IMAGE" style="width: 62px;height: 62px;margin-right: 20px;"
                                        :src="'https://xunjiah.mkaka.icu' + price_form.IMAGE" alt="凭证预览">
                                    <!-- 上传组件 -->
                                    <my-upload style="margin: 0;" :limit="1" :auto-upload="true"
                                        @change="handleFileChange" @success="handleUploadSuccess1"
                                        @error="handleUploadError" />
                                </div>
                            </el-form-item>
                        </el-form>
                    </div>
                    <!-- 对话框底部按钮 -->
                    <span slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="money_submit()">确 定</el-button>
                    </span>
                </div>

            </template>
        </div>

        <!-- 缴纳保证金对话框 -->
        <el-dialog :show-close="false" title="缴纳保证金" :visible.sync="dialogVisible1" width="36%" center>
            <div class="dialog_content">
                <!-- 公司名称 -->
                <div class="title_">
                    {{ userInfo.COMPANY_NAME }}
                </div>
                <!-- 保证金信息 -->
                <!-- <div class="money_box">
            <div class="item_price">
              保证金:
              <span style="color: #c31424;">{{ userInfo.TOTAL_MONEY || 0 }}</span>
            </div>
            <div class="item_price">
              冻结保证金:
              <span style="color: #c31424;">{{ userInfo.FREEZE_MONEY || 0 }}</span>
            </div>
            <div class="item_price">
              可用保证金:
              <span style="color: #c31424;">{{ userInfo.USABLE_MONEY || 0 }}</span>
            </div>
          </div> -->

                <!-- 缴纳保证金表单 -->
                <el-form :model="price_form" :rules="rules9" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <!-- 所属业务中心 -->
                    <el-form-item label-width="150" label="所属业务中心" prop="DEPID">
                        <el-select v-model="price_form.DEPID" placeholder="请选择缴纳所属业务中心">
                            <el-option v-for="item in department_list" :key="item.ID" :label="item.TITLE"
                                :value="item.ID">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <!-- 缴纳时间 -->
                    <el-form-item label="缴纳时间" prop="JNDJ_TIME">
                        <el-date-picker v-model="price_form.JNDJ_TIME" format="yyyy-MM-dd" type="date"
                            placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <!-- 缴纳金额 -->
                    <el-form-item label="缴纳金额" prop="MONEY">
                        <el-input type="number" v-model="price_form.MONEY"></el-input>
                    </el-form-item>
                    <!-- 缴纳凭证 -->
                    <el-form-item label="缴纳金凭证" prop="IMAGE">
                        <div style="display: flex;">
                            <!-- 凭证图片预览 -->
                            <img v-if="price_form.IMAGE" style="width: 62px;height: 62px;margin-right: 20px;"
                                :src="'https://xunjiah.mkaka.icu' + price_form.IMAGE" alt="凭证预览">
                            <!-- 上传组件 -->
                            <my-upload style="margin: 0;" :limit="1" :auto-upload="true" @change="handleFileChange"
                                @success="handleUploadSuccess1" @error="handleUploadError" />
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <!-- 对话框底部按钮 -->
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="money_submit()">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 已移除华东验证码组件 -->
        <!-- <div style="width: 350px;">
        <huadong></huadong>
      </div> -->

    </div>
</template>

<script>
// 引入我的竞标子组件
import wdjb from '@/components/view/wdjb.vue'
// 假设 my-upload 是全局注册或按需引入的

export default {
    components: {
        wdjb // 注册我的竞标组件
    },
    data() {
        return {
            is_zan_cun: 0,
            loading: true,
            base_url: 'https://xunjiah.mkaka.icu',
            dataEntries_: [],
            upload_info_index: '',
            upload_info_list: [],
            status_: 120,
            status_content: '',
            // --- 状态控制 ---
            cli: 2, // 左侧导航选中状态 (1: 我的竞标, 2: 企业信息)
            cli2: 0, // 我的竞标内标签页状态 (0: 待参与, 1: 已参与)
            is_information: 2, // 是否显示企业信息区域 (true: 显示企业信息, false: 显示我的竞标)
            is_show: false, // 企业信息表单内容是否显示 (通常在数据加载后设为 true)
            is_department: '', // 当前选中的业务中心ID
            dialogVisible1: false, // 缴纳保证金对话框是否可见
            isSubmitting: false, // 是否正在提交企业信息表单，防止重复提交

            // --- 数据存储 ---
            userInfo: {}, // 用户信息 (从 localStorage 获取)
            department_list: [], // 业务中心列表
            dataJson: [], // 企业信息表单结构定义 (从 API 获取)
            form_all: { // 存储企业信息表单的实际数据
                formData1: [{}], // 存储 SHOP_INFO 等表的动态表单数据，数组索引对应 dataJson
                upload_datas: [{}], // 存储 SHOP_RZ 表（资质信息）的动态表单数据
                zzxx_datas: [{}], // 资质信息
                upload_info_list: [],
            },
            form: { // 存储部分固定结构的表单数据，如财务表格
                data: [ // 财务信息表格数据
                    { "years": new Date().getFullYear(), "ygzs": "", "xssr": "", "ndlr": "" },
                ],
            },
            price_form: { // 缴纳保证金表单数据
                JNDJ_TIME: '', // 缴纳时间
                MONEY: '', // 缴纳金额
                IMAGE: '', // 凭证图片路径
                DEPID: '', // 所属业务中心ID
            },

            // --- 表单验证规则 ---
            rules: { // 企业信息主表单的验证规则 (部分示例，很多在模板内联定义)
                // 动态生成的校验规则会被添加到这里，或者直接在 el-form-item 的 :rules 中定义
                "data.0.years": [{ required: true, message: "请输入年份", trigger: "blur" }], // 示例：财务表格年份
                // ... 其他内联或动态添加的规则
            },
            rules9: { // 缴纳保证金表单的验证规则
                JNDJ_TIME: [
                    { required: true, message: '请选择缴纳时间', trigger: 'change' }, // trigger改为change更适合日期选择
                ],
                MONEY: [
                    { required: true, message: '请输入缴纳金额', trigger: 'blur' },
                ],
                IMAGE: [
                    { required: true, message: '请上传凭证', trigger: 'change' }, // trigger改为change可能更适合上传组件状态
                ],
                DEPID: [
                    { required: true, message: '请选择缴纳所属业务中心', trigger: 'change' }, // trigger改为change更适合下拉选择
                ],
            },

            // --- 辅助变量 ---
            submitDebounce: null, // 保存防抖函数的引用
            formData1_index: '', // 临时存储文件上传对应的 formData1 的索引
            formData1_a: '', // 临时存储文件上传对应的字段名 (COLUMN_NAME)

        };
    },
    computed: {
        /**
         * @description 处理图片路径字符串，分割成数组用于预览
         * @param {String} e 图片路径字符串，逗号分隔
         * @returns {Array} 图片路径数组
         */
        handle_image_l() {
            return function (e) {
                // 检查输入是否为非空字符串
                if (typeof e === 'string' && e) {
                    // 按逗号分割字符串
                    return e.split(',');
                }
                // 如果输入无效，返回空数组
                return [];
            }
        },

        /**
         * @description 处理下拉或复选框的选项字符串，分割成数组
         * @param {String} e 选项字符串，通常用 '、' 分隔
         * @returns {Array} 选项数组
         */
        handleTransition() {
            return function (e) {
                let arr = [];
                if (typeof e === 'string') {
                    arr = e.split('、'); // 使用中文顿号分割
                }
                return arr;
            }
        },

        /**
         * @description 判断财务表格的行是否可以删除 (第一行不允许删除)
         * @param {Number} e 行索引
         * @returns {Boolean} 是否禁用删除按钮 (true: 禁用, false: 不禁用)
         */
        handle_is_del() {
            return function (e) {
                return e == 0; // 索引为 0 的行不可删除
            }
        },

        // --- 已移除的未使用 computed 属性 ---
        // selectedValues: { ... } // 处理复选框值的 getter/setter，未使用
    },
    created() {
        // 初始化提交按钮的防抖函数
        this.submitDebounce = this.debounce(this._submitForm, 500); // 500ms 防抖
    },
    mounted() {
        // 从 localStorage 获取用户信息
        const storedUserInfo = localStorage.getItem('user_info');
        if (storedUserInfo) {
            this.userInfo = JSON.parse(storedUserInfo);
        }
        // 获取业务中心列表 (成功后会接着获取表单结构和数据)
        this.get_table_list();
        // 初始化 IntersectionObserver (当前为空实现)
        this.initObserver();

        // --- 已移除的未使用逻辑 ---
        // setTimeout(() => { ... }, 2000); // 示例数据赋值
    },
    methods: {
        handle_cli(e) {
            console.log(e, '----->');
        },
        handleRemoveFile(i, e) {
            this.form_all.upload_info_list[i].VALUE.splice(e, 1)
            console.log(i, e, '----->');
        },
        /**
         * @description 子组件 wdjb 点击行时触发的事件处理
         * @param {any} row 子组件传递的行数据 (通常是项目ID)
         */
        row_click(row) {
            console.log('子组件行点击:', row);
            // 将项目ID存入localStorage，供详情页或其他页面使用
            localStorage.setItem('get_info_id', row);
            // 使用 $nextTick 确保DOM更新后再触发事件 (如果需要)
            this.$nextTick(() => {
                // 向父组件或其他监听者发送 'handleClick' 事件 (如果父组件监听了此事件)
                // 参数: 1 (标识操作类型), '12' (标识场景), row (数据)
                this.$emit('handleClick', 1, '12', row);
            });
        },

        /**
         * @description 处理文件上传失败
         * @param {Error} e 错误对象
         * @param {File} file 上传的文件对象
         */
        handleUploadError(e, file) {
            console.error('上传失败:', e, file);
            this.$message.error('文件上传失败，请重试');
        },

        /**
         * @description 防抖函数
         * @param {Function} func 需要防抖的函数
         * @param {Number} wait 延迟时间 (毫秒)
         * @returns {Function} 包装后的防抖函数
         */
        debounce(func, wait) {
            let timeout;
            return function (...args) {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    func.apply(this, args);
                }, wait);
            };
        },

        async get_upload_info() {

            try {
                const res = await this.$http.post('/api/common/get_upload_info', {
                    id: this.is_department
                });
                if (res.data.code === 200) {
                    if (this.upload_info_list.length != 0) return
                    this.upload_info_list = res.data.data
                    this.form_all.upload_info_list = res.data.data
                    this.form_all.upload_info_list.forEach(item => {
                        item.VALUE = []
                    })
                    console.log(this.upload_info_list, '---this.upload_info_list-->');
                } else {
                    this.$message.error(res.data.msg || '获取业务中心列表失败');
                }
            } catch (error) {
                console.error("获取业务中心列表失败:", error);
                this.$message.error('网络错误，获取业务中心列表失败');
            }
        },

        /**
         * @description 获取业务中心列表，并在成功后获取表单结构和默认数据
         */
        async get_table_list() {
            try {
                const res = await this.$http.post('/api/common/get_department_list', {});
                if (res.data.code === 200) {
                    this.department_list = res.data.data;
                    // 如果列表不为空，默认选中第一个业务中心
                    if (this.department_list.length > 0) {
                        // 仅在 is_department 未设置或与第一个不同时才设置，避免不必要的刷新
                        if (!this.is_department || this.is_department !== this.department_list[0].ID) {
                            this.is_department = this.department_list[0].ID;
                            this.get_upload_info()

                        }
                        // 获取该业务中心对应的表单结构和已保存的数据
                        this.get_form_list();
                        // this.get_zzqd_list(); // 获取资质清单接口调用被移除
                    }
                    // 刷新我的竞标列表 (在 wdjb 子组件中获取)
                    this.$refs.wdjb?.get_table_list(); // 使用可选链确保 ref 存在
                } else {
                    this.$message.error(res.data.msg || '获取业务中心列表失败');
                }
            } catch (error) {
                console.error("获取业务中心列表失败:", error);
                this.$message.error('网络错误，获取业务中心列表失败');
            }
        },

        /**
         * @description 获取指定业务中心的表单结构定义
         */
        async get_form_list() {
            if (!this.is_department) return; // 必须有业务中心 ID
            this.is_show = false; // 获取新结构前先隐藏表单，防止旧数据显示
            try {
                const res = await this.$http.post('/api/common/get_forms_info', {
                    id: this.is_department
                });
                if (res.data.code === 200) {
                    this.dataJson = res.data.data;
                    console.log('获取到的表单结构:', this.dataJson);

                    // 初始化 form_all 数据结构以匹配 dataJson
                    this.form_all.formData1 = []; // 清空旧数据
                    this.form_all.upload_datas = [{}]; // 重置资质上传数据

                    this.dataJson.forEach((section, index) => {
                        if (section.TABLE_NAME !== 'SHOP_RZ') {
                            // 初始化非资质表单的数据对象
                            const sectionData = {};
                            section.lists.forEach(field => {
                                // 根据字段类型设置初始值 (复选框为空数组，其他为空字符串)
                                sectionData[field.COLUMN_NAME] = field.COLUMN_STYLE == 4 ? [] : '';
                            });
                            this.form_all.formData1.push(sectionData);
                        } else {
                            // 初始化资质表单的数据对象 (假设只有一个资质表 SHOP_RZ)
                            const uploadSectionData = {};
                            section.lists.forEach(field => {
                                // 资质上传字段初始化为空字符串或空数组（根据 handle_image_l 的处理逻辑，字符串可能更合适）
                                uploadSectionData[field.COLUMN_NAME] = '';
                            });
                            this.$set(this.form_all.upload_datas, 0, uploadSectionData); // 显式设置以确保响应性
                        }
                    });

                    console.log('初始化后的 form_all:', JSON.parse(JSON.stringify(this.form_all))); // 深拷贝打印

                    // 使用 nextTick 确保 DOM 更新后再获取已保存的表单数据
                    this.$nextTick(() => {
                        this.get_form_data(); // 获取该业务中心下已保存的用户数据
                    });

                } else {
                    this.$message.error(res.data.msg || '获取表单结构失败');
                }
            } catch (error) {
                console.error("获取表单结构失败:", error);
                this.$message.error('网络错误，获取表单结构失败');
            }
        },


        /**
         * @description 初始化 Intersection Observer API (当前为空实现)
         * 可用于检测元素是否进入视口，例如实现滚动定位导航高亮等功能
         */
        initObserver() {
            // TODO: 实现 Intersection Observer 逻辑 (如果需要)
            console.log('Intersection Observer 初始化 (空实现)');
        },

        /**
         * @description 添加财务信息表格的新行
         */
        addRow1() {
            // 计算新年份 (比最后一行年份减 1，如果为空则使用当前年份)
            let year = this.form.data.length === 0 ? new Date().getFullYear() : parseInt(this.form.data[this.form.data.length - 1].years) - 1;
            // 检查年份是否有效，防止NaN
            if (isNaN(year)) {
                year = new Date().getFullYear() - this.form.data.length; // 备用逻辑
            }
            this.form.data.push({ "years": year.toString(), "ygzs": "", "xssr": "", "ndlr": "" });
            console.log(this.form.data, '---form.data-->');
        },

        /**
         * @description 删除财务信息表格的指定行
         * @param {Number} index 要删除的行索引
         */
        deleteRow1(index) {
            // 防止删除第一行（如果业务逻辑如此）
            if (index === 0) {
                this.$message.warning('第一行财务信息不能删除');
                return;
            }
            this.form.data.splice(index, 1);
        },

        /**
         * @description 提交缴纳保证金表单
         */
        money_submit() {
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    // 处理时间格式：将日期对象转换为秒级时间戳
                    let timestampInSeconds = '';
                    if (this.price_form.JNDJ_TIME instanceof Date) {
                        timestampInSeconds = Math.floor(this.price_form.JNDJ_TIME.getTime() / 1000);
                    } else if (typeof this.price_form.JNDJ_TIME === 'string' && this.price_form.JNDJ_TIME) {
                        // 如果是字符串格式，尝试解析（可能需要更健壮的解析）
                        timestampInSeconds = Math.floor(new Date(this.price_form.JNDJ_TIME).getTime() / 1000);
                    } else {
                        this.$message.error('缴纳时间格式不正确');
                        return; // 停止提交
                    }
                    if (isNaN(timestampInSeconds)) {
                        this.$message.error('缴纳时间无效，请重新选择');
                        return;
                    }


                    const payload = {
                        ...this.price_form,
                        JNDJ_TIME: timestampInSeconds
                    };

                    try {
                        const res = await this.$http.post('/api/user/payment', payload);
                        if (res.data.code === 200) {
                            this.$message({
                                message: res.data.msg || '保证金缴纳信息提交成功',
                                type: 'success'
                            });
                            this.dialogVisible1 = false; // 关闭对话框
                            // 清空表单
                            this.$refs.ruleForm.resetFields(); // 重置表单验证和值
                            this.price_form.IMAGE = ''; // 手动清空上传的图片路径

                            // 可能需要刷新用户信息或保证金余额显示
                            // this.get_user_detail(); // 假设有此方法获取最新用户信息
                            // 更新本地 userInfo 数据（如果接口不返回最新数据）
                            const moneyToAdd = parseFloat(this.price_form.MONEY);
                            if (!isNaN(moneyToAdd)) {
                                this.userInfo.TOTAL_MONEY = (parseFloat(this.userInfo.TOTAL_MONEY || 0) + moneyToAdd).toFixed(2);
                                this.userInfo.USABLE_MONEY = (parseFloat(this.userInfo.USABLE_MONEY || 0) + moneyToAdd).toFixed(2);
                            }
                            // 清空金额避免下次打开残留
                            this.price_form.MONEY = '';
                            this.price_form.DEPID = ''; // 清空下拉选择

                        } else {
                            this.$message.error(res.data.msg || '提交失败');
                        }
                    } catch (error) {
                        console.error("缴纳保证金失败:", error);
                        this.$message.error('网络错误，缴纳保证金失败');
                    }

                } else {
                    console.log('缴纳保证金表单验证失败');
                    return false;
                }
            });
        },
        /**
            * @description: 下载文件
            * @param {string} url 文件下载地址
            */
        download(url) {
            let url_ = ''
            if (url) {
                if (!url.startsWith("http://") && !url.startsWith("https://")) {
                    url_ = `https://xunjiah.mkaka.icu/${url.replace(/^\//, '')}`;
                } else {
                    url_ = url
                }
                window.open(url_, "_blank");
                console.log(url_, '----->');
            } else {
                this.$message.warning('文件地址无效')
            }
        },
        handleUploadSuccess_upload_info(response) {
            if (response.code === 200 && response.data?.FILEPATH) {
                this.$message({ message: '上传成功', type: 'success' });
                this.$nextTick(() => {
                    this.form_all.upload_info_list[this.upload_info_index].VALUE.push(response.data)
                    this.form_all.upload_info_list = JSON.parse(JSON.stringify(this.form_all.upload_info_list))
                    console.log(this.form_all.upload_info_list, '---this.form_all.upload_info_list-->');
                })
                // this.price_form.IMAGE = response.data.FILEPATH; // 更新图片路径
                // 手动触发一次表单项验证，清除“请上传凭证”的错误提示
            } else {
                this.$message.error(response.msg || '凭证上传失败');
            }
            console.log('缴纳凭证上传响应:', response);
        },

        /**
         * @description 处理缴纳保证金凭证上传成功
         * @param {Object} response 服务器响应
         */
        handleUploadSuccess1(response) {
            if (response.code === 200 && response.data?.FILEPATH) {
                this.$message({ message: '凭证上传成功', type: 'success' });
                this.price_form.IMAGE = response.data.FILEPATH; // 更新图片路径
                // 手动触发一次表单项验证，清除“请上传凭证”的错误提示
                this.$refs.ruleForm.validateField('IMAGE');
            } else {
                this.$message.error(response.msg || '凭证上传失败');
            }
            console.log('缴纳凭证上传响应:', response);
        },


        // 转换函数：确保 VALUE 始终是数组
        normalizeValue(data) {
            let data_ = data.map(item => {
                // 如果 VALUE 是对象（但不是数组），则包装成数组
                if (item.VALUE && !Array.isArray(item.VALUE)) {
                    item.VALUE = [item.VALUE];
                }
                // 如果 VALUE 是 null 或 undefined，设为空数组
                else if (!item.VALUE) {
                    item.VALUE = [];
                }
                return item;
            });
            this.form_all.upload_info_list = data_
            console.log('获取到的已存表单数据:', this.form_all.upload_info_list);

        },



        /**
         * @description 获取指定业务中心下已保存的企业信息数据
         */
        async get_form_data() {
            if (!this.is_department) return;
            try {
                const res = await this.$http.post('/api/user/shop_dep', {
                    dep_id: this.is_department
                });

                if (res.data.code === 200 && res.data.data?.datas) {
                    const dataEntries = res.data.data.datas;
                    this.dataEntries_ = res.data.data.datas;
                    this.status_ = res.data.data.status
                    this.status_content = res.data.data.reason
                    this.normalizeValue(res.data.data.upload_datas)
                    dataEntries.forEach(item => {
                        if (item.tablename == "SHOP_CAIWU") {
                            // 先检查 data_column 是否存在且不为 null
                            if (item.data_column && item.data_column.SALARYS) {
                                this.form.data = JSON.parse(item.data_column.SALARYS || "[]");
                                console.log(this.form.data, '--- this.form.data-->');
                            } else {
                                console.error("data_column is null or SALARYS is missing:", item);
                                this.form.data = []; // 设置默认值，避免后续代码报错
                            }
                        }
                    });
                    // this.form_all.upload_info_list = res.data.data.upload_datas

                    // 遍历API返回的数据条目
                    dataEntries.forEach((entry, apiIndex) => {
                        // 找到 dataJson 中对应的表定义 (根据 TABLE_NAME 匹配)
                        const formDefinitionIndex = this.dataJson.findIndex(def => def.TABLE_NAME === entry.tablename);

                        if (formDefinitionIndex !== -1) {
                            const dataColumn = entry.data_column;
                            if (dataColumn) {
                                // 根据表名判断是更新 formData1 还是 upload_datas
                                if (entry.tablename !== 'SHOP_RZ') {
                                    // 更新 formData1
                                    Object.entries(dataColumn).forEach(([key, value]) => {
                                        // 检查表单定义，如果是复选框且值为字符串，则转为数组
                                        const fieldDefinition = this.dataJson[formDefinitionIndex].lists.find(f => f.COLUMN_NAME === key);
                                        if (fieldDefinition && fieldDefinition.COLUMN_STYLE == 4 && typeof value === 'string') {
                                            // 安全地分割，即使是空字符串也返回空数组
                                            this.$set(this.form_all.formData1[formDefinitionIndex], key, value ? value.split(',') : []);
                                        } else {
                                            this.$set(this.form_all.formData1[formDefinitionIndex], key, value);
                                        }
                                    });
                                } else {
                                    // 更新 upload_datas (资质信息)
                                    Object.entries(dataColumn).forEach(([key, value]) => {
                                        // 资质上传通常保存为字符串路径，直接赋值
                                        this.$set(this.form_all.upload_datas[0], key, value); // 假设资质总在 upload_datas[0]
                                    });
                                }
                            }
                        } else {
                            console.warn(`未在 dataJson 中找到表名为 ${entry.tablename} 的定义`);
                        }
                    });

                    // 数据填充完毕后，显示表单内容
                    this.is_show = true;
                    console.log('填充数据后的 form_all:', JSON.parse(JSON.stringify(this.form_all)));
                    this.loading = false
                } else if (res.data.code === 200) {
                    // code 200 但没有 data.datas，说明是新用户或该业务中心无数据
                    console.log('该业务中心无已保存的企业信息');
                    this.is_show = true; // 仍然显示空表单
                } else {
                    this.$message.error(res.data.msg || '获取企业信息失败');
                }
            } catch (error) {
                console.error("获取企业信息失败:", error);
                this.$message.error('网络错误，获取企业信息失败');
            } finally {
                // 确保即使出错也尝试显示表单（可能是空表单）
                if (!this.is_show) this.is_show = true;
            }
        },

        /**
         * @description 处理表单数据，将数组类型（如复选框）转换为逗号分隔的字符串，并移除 NUMROW 字段
         * @param {Array} formData 表单数据数组 (e.g., form_all.formData1 or form_all.upload_datas)
         * @returns {Array} 处理后的数据数组
         */
        processFormData(formData) {
            if (!Array.isArray(formData)) return []; // 防御性编程
            return formData.map(item => {
                // 确保 item 是对象
                if (typeof item !== 'object' || item === null) return {};
                const processedItem = { ...item }; // 创建副本
                for (const key in processedItem) {
                    // 如果值是数组，则用逗号连接成字符串
                    if (Array.isArray(processedItem[key])) {
                        processedItem[key] = processedItem[key].join(',');
                    }
                }
                // delete processedItem.NUMROW; // 如果有 NUMROW 字段需要移除
                return processedItem;
            });
        },

        /**
         * @description 滚动到第一个未通过验证的表单字段
         */
        scrollToFirstInvalidField() {
            // $refs.form 可能尚未渲染完成，需要检查
            if (!this.$refs.form || !this.$refs.form.fields) {
                console.warn('表单引用尚未准备好，无法滚动到无效字段');
                return;
            }
            // 查找第一个校验状态为 error 的字段
            const firstInvalidField = this.$refs.form.fields.find(field => field.validateState === 'error');

            if (firstInvalidField && firstInvalidField.prop) {
                // 尝试获取字段对应的 DOM 元素
                // Element UI 的 el-form-item 可能嵌套较深，直接用 prop 查询可能不准确
                // 尝试更通用的方式获取 el-form-item 元素
                const fieldElement = firstInvalidField.$el; // 获取 el-form-item 的根元素

                if (fieldElement && typeof fieldElement.scrollIntoView === 'function') {
                    // 滚动到视图中央
                    fieldElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    // 尝试聚焦内部的输入控件
                    const inputElement = fieldElement.querySelector('input, textarea, .el-select, .el-date-editor');
                    if (inputElement && typeof inputElement.focus === 'function') {
                        // 使用 setTimeout 确保滚动完成后再聚焦
                        setTimeout(() => inputElement.focus(), 300); // 延迟聚焦
                    }
                } else {
                    console.warn(`无法找到或滚动到属性为 ${firstInvalidField.prop} 的无效字段`);
                }
            }
        },

        handle_number(e) {
            return Number(e)
        },
        checkFieldsNotEmpty(data) {
            for (const item of data) {
                if (
                    item.years === null || item.years === undefined || item.years === "" ||
                    item.ygzs === null || item.ygzs === undefined || item.ygzs === "" ||
                    item.xssr === null || item.xssr === undefined || item.xssr === "" ||
                    item.ndlr === null || item.ndlr === undefined || item.ndlr === ""
                ) {
                    return false;
                }
            }
            return true;
        },
        /**
         * @description 实际执行表单提交的内部方法 (由防抖函数调用)
         */
        async _submitForm() {
            // let status_ = 10
            // this.dataJson.forEach(item => {
            //     if (item.TABLE_NAME == "SHOP_CAIWU") {
            //         item.lists.forEach(i => {
            //             if (i.NAME == '近3年营业收入') {
            //                 status_ = i.IS_RULES
            //             }
            //         })
            //         console.log(item, '--- itemitemitemitem-->');
            //     }
            // })
            // const is_true = this.checkFieldsNotEmpty(this.form.data)
            // console.log(is_true, '--is_trueis_true--->');
            // if (status_ == 1 && is_true == false) {
            //     this.$message.error('近三年数据不能为空');
            //     this.isSubmitting = false;

            //     return
            // }
            if (this.isSubmitting) return; // 防止重复提交
            this.isSubmitting = true;

            try {


                // 准备需要提交的数据
                const { form_all, dataJson, userInfo, is_department } = this;

                // 处理需要提交的表单数据 (将数组转为字符串等)
                const processedFormData = this.processFormData(form_all.formData1);
                const processedUploadData = this.processFormData([form_all.upload_datas[0]]);

                // 构建提交到后端的 datas 结构
                const submitData = dataJson
                    .map((item, index) => {
                        if (item.TABLE_NAME !== 'SHOP_RZ') {
                            // --- START FIX ---
                            // 从处理过的数据中获取对应部分
                            const originalDataColumn = processedFormData[index] || {};
                            // 创建副本以避免修改原始 processedFormData
                            const dataColumnToSend = { ...originalDataColumn };
                            // 从副本中删除 NUMROW 字段 (如果存在)
                            delete dataColumnToSend.NUMROW;
                            // --- END FIX ---
                            return {
                                tablename: item.TABLE_NAME,
                                data_column: dataColumnToSend // 使用清理过的副本
                            };
                        }
                        return null; // 过滤掉资质表定义
                    })
                    .filter(item => item !== null); // 移除 null

                // 处理资质信息 (SHOP_RZ)
                const rzTableDefinition = dataJson.find(item => item.TABLE_NAME === 'SHOP_RZ');
                let uploadSubmitData = null;
                if (rzTableDefinition) {
                    // --- START FIX ---
                    const originalUploadDataColumn = processedUploadData[0] || {};
                    // 创建副本
                    const uploadDataColumnToSend = { ...originalUploadDataColumn };
                    // 从副本中删除 NUMROW 字段 (如果存在)
                    delete uploadDataColumnToSend.NUMROW;
                    // --- END FIX ---
                    uploadSubmitData = {
                        tablename: rzTableDefinition.TABLE_NAME,
                        data_column: uploadDataColumnToSend // 使用清理过的副本
                    }
                } else {
                    console.warn('未找到 SHOP_RZ 的表定义，无法提交资质信息');
                }


                const upload_list = this.form_all.upload_info_list.map(item => {
                    const key = item.COLUMN_NAME;
                    const value = item.VALUE.map(file => file.ID).join(",");  // 将数组元素用逗号连接
                    // const value = item.DOCS_ARR.FILEPATH.join(","); // 将数组元素用逗号连接
                    return { [key]: value };
                });

                submitData.forEach(item => {
                    if (item.tablename == "SHOP_CAIWU") {
                        item.data_column.SALARYS = JSON.stringify(this.form.data)
                    }
                })
                console.log(submitData, '--submitData--->');

                // 准备最终提交的 payload
                const payload = {
                    depid: is_department,
                    shop_id: userInfo.ID,
                    // 合并普通数据和资质数据（确保都已清理 NUMROW）
                    datas: JSON.stringify(submitData.concat(uploadSubmitData ? [uploadSubmitData] : [])),
                    upload_datas: JSON.stringify(upload_list),
                };
                console.log('准备提交的数据 (payload):', payload);


                // 验证整个表单
                try {
                    console.log(this.is_zan_cun, '--this.is_zan_cun--->');
                    if (this.is_zan_cun == 2) {
                        console.log(this.is_zan_cun, '--this.thisthisthisthisthis--->');

                        const [validForm, validForm1] = await Promise.all([
                            new Promise(resolve => this.$refs.form.validate(resolve)),
                            new Promise(resolve => this.$refs.form1.validate(resolve))
                        ]);
                        if (validForm && validForm1) {
                            // 所有表单校验通过，执行提交
                            const res = await this.$http.post('/api/user/updateShopxx', payload);
                            if (res.data.code === 200) {
                                this.$message.success('保存成功');
                                this.get_table_list();
                            } else {
                                this.$message.error(res.data.msg || '保存失败');
                            }
                        } else {
                            this.$message.error('请检查表单填写是否正确');
                            this.scrollToFirstInvalidField(); // 滚动到第一个错误字段
                        }
                    } else {
                        // 所有表单校验通过，执行提交
                        const res = await this.$http.post('/api/user/tsShopxx', payload);
                        if (res.data.code === 200) {
                            this.$message.success('保存成功');
                            this.get_table_list();
                        } else {
                            this.$message.error(res.data.msg || '保存失败');
                        }
                    }

                } catch (error) {
                    console.error('提交失败:', error);
                    this.$message.error('网络错误，请稍后重试');
                } finally {
                    this.isSubmitting = false;
                }

            } catch (error) {
                // 提交前的准备阶段出错 (例如数据处理)
                console.error('准备提交数据时出错:', error);
                this.$message.error('处理表单数据时出错，请稍后重试');
                this.isSubmitting = false; // 解除提交锁定
            }
        },


        /**
         * @description 公开的提交方法，供模板中的按钮调用 (触发防抖)
         */
        submitForm(e) {
            this.is_zan_cun = e
            if (this.isSubmitting) {
                this.$message.warning('正在提交中，请稍候...');
                return;
            }
            console.log('触发提交 (将调用防抖函数)');
            this.submitDebounce(e);
        },

        /**
         * @description 文件状态改变时的回调 (选择文件、移除文件等)
         * @param {Number} index 表单区域索引 (对于 SHOP_RZ 固定为 0)
         * @param {String} fieldName 字段名 (COLUMN_NAME)
         */
        handleFileChange(index, fieldName) {
            // 记录当前操作的字段，供 handleUploadSuccess 使用
            // 注意：对于 SHOP_RZ，index 应为 0
            const targetIndex = this.dataJson.find(item => item.TABLE_NAME === 'SHOP_RZ') ? 0 : index;
            this.formData1_index = targetIndex; // 使用修正后的索引
            this.formData1_a = fieldName;
            console.log(`文件状态改变: index=${this.formData1_index}, field=${this.formData1_a}`);
        },

        handleFileChange_upload_info(index, fieldName) {
            this.upload_info_index = index
            console.log(this.upload_info_index, '---this.upload_info_index-->');
        },

        /**
         * @description 文件上传成功的回调
         * @param {Object} response 服务器响应
         * @param {File} file 上传的文件对象
         * @param {Array} fileList 当前文件列表
         */
        handleUploadSuccess(response, file, fileList) {
            console.log('文件上传成功响应:', response);
            if (response.code === 200 && response.data?.FILEPATH) {
                const filePath = response.data.FILEPATH;
                const index = this.formData1_index; // 获取之前记录的索引
                const fieldName = this.formData1_a; // 获取之前记录的字段名

                if (index === undefined || fieldName === undefined) {
                    console.error('无法确定文件上传对应的字段');
                    this.$message.error('文件信息关联失败，请重试');
                    return;
                }

                // 根据索引判断是更新 formData1还是 upload_datas
                // 假设 index 0 对应 upload_datas，其他对应 formData1
                // 需要根据实际 dataJson 结构调整此逻辑，更可靠的方式是判断 fieldName 是否属于 SHOP_RZ
                let targetObject;
                let isUploadDatas = false;
                const rzDefinition = this.dataJson.find(item => item.TABLE_NAME === 'SHOP_RZ');
                if (rzDefinition && rzDefinition.lists.some(f => f.COLUMN_NAME === fieldName)) {
                    targetObject = this.form_all.upload_datas[0]; // 资质上传对象
                    isUploadDatas = true;
                } else if (this.form_all.formData1[index]) {
                    targetObject = this.form_all.formData1[index]; // 普通表单对象
                }


                if (targetObject) {
                    // 获取当前字段的值 (可能不存在或是字符串)
                    let currentValue = targetObject[fieldName];
                    let updatedValue;

                    // 检查当前值是否为数组 (理论上初次上传或非多图上传时不是)
                    // 改为检查是否为非空字符串，追加新路径
                    if (typeof currentValue === 'string' && currentValue) {
                        // 如果已存在路径字符串，用逗号追加
                        updatedValue = currentValue + ',' + filePath;
                    } else {
                        // 如果为空或不是字符串，直接设置为新路径
                        updatedValue = filePath;
                    }

                    // 使用 $set 更新以确保响应性
                    this.$set(targetObject, fieldName, updatedValue);

                    this.$message.success('文件上传成功');
                    // 手动触发一次表单项验证（如果需要）
                    const propPath = isUploadDatas ? `upload_datas.0.${fieldName}` : `formData1.${index}.${fieldName}`;
                    this.$refs.form?.validateField(propPath);


                } else {
                    console.error(`找不到对应的表单数据对象: index=${index}, isUploadDatas=${isUploadDatas}`);
                    this.$message.error('更新文件路径失败');
                }

            } else {
                this.$message.error(response.msg || '文件上传处理失败');
            }
            // 清空临时变量
            // this.formData1_index = '';
            // this.formData1_a = '';
        },

        /**
         * @description 处理左侧导航切换
         * @param {Number} e 导航项标识 (1: 我的竞标, 2: 企业信息)
         */
        handleSwitch(e) {
            this.is_information = e; // 显示企业信息区域

            if (this.cli === e) return; // 点击当前项不作处理

            this.cli = e; // 更新左侧导航选中状态
            if (e === 2) {
                // this.is_information = true; // 显示企业信息区域
                // 切换到企业信息时，确保已加载或重新加载当前选中业务中心的数据
                if (!this.dataJson.length || !this.is_department) {
                    this.get_table_list(); // 如果还没有业务中心或表单结构，则加载
                } else {
                    this.get_form_list(); // 如果已有业务中心，重新加载该业务中心的表单
                }
            } if (e === 3) {
                // this.is_information = true; // 显示企业信息区域
                // 切换到企业信息时，确保已加载或重新加载当前选中业务中心的数据
                if (!this.dataJson.length || !this.is_department) {
                    this.get_table_list(); // 如果还没有业务中心或表单结构，则加载
                } else {
                    this.get_form_list(); // 如果已有业务中心，重新加载该业务中心的表单
                }
            } else {
                // this.is_information = false; // 显示我的竞标区域
                // 切换回我的竞标时，刷新列表
                this.$nextTick(() => {
                    this.$refs.wdjb?.get_table_list();
                });
            }
        },

        /**
         * @description 处理我的竞标内的标签页切换 (待参与/已参与)
         * @param {Number} e 标签页标识 (0: 待参与, 1: 已参与)
         */
        handleSekect(e) {
            if (this.cli2 === e) return; // 点击当前项不作处理

            this.cli2 = e; // 更新标签页选中状态
            // 通知子组件更新列表查询条件
            if (this.$refs.wdjb) {
                this.$refs.wdjb.join_type = e; // 设置子组件的查询类型
                this.$nextTick(() => {
                    this.$refs.wdjb.get_table_list(); // 触发子组件刷新列表
                });
            }
        },

        /**
         * @description 处理企业信息下业务中心的切换
         * @param {String|Number} e 选中的业务中心 ID
         */
        handleQyxx(e) {
            if (this.is_department === e) return; // 点击当前项不作处理

            this.is_department = e; // 更新当前选中的业务中心 ID
            this.get_upload_info()

            // this.cli3 = e; // cli3 已移除
            this.get_form_list(); // 获取新选中的业务中心的表单结构和数据
        },

    },
};
</script>

<style lang="scss" scoped>
.checkbox_style ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #0256FF;
}

html {
    overflow-y: scroll;
    /* 始终显示垂直滚动条 */
}

.el_radio {
    margin-top: 10px;
}

.form_item {
    margin-bottom: 20px !important;
}

.form_item ::v-deep .el-form-item__content {
    margin-left: 0 !important;
    width: 100%;
}

// .form_item ::v-deep .el-form-item__error {
//   top: 71% !important;
// }

::v-deep .el-upload--picture-card {
    // 图片上传区域样式
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    border: 0;
}

::v-deep .el-upload-list__item {
    //transition: none;  // 禁用上传删除动画
    transition-duration: 0.2s; // 或者不禁用，修改动画时间
}

::v-deep .el-upload-dragger {
    // 图片拖拽区域样式
    height: 100%;
    //background-color: black;
    border: none;
    line-height: 100px;

    .el-upload__text {
        // 拖拽区域文本区样式
        line-height: 1px;
    }
}


.container {
    width: 1500px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 20px;
    padding-top: 20px;
}

.left-nav {
    min-width: 200px;
    background: #f5f5f5;
    z-index: 10;

    .nav-item {
        padding: 15px 20px;
        cursor: pointer;
        display: flex;
        align-items: center;
        font-size: 16px;


        &.active {
            background: #c8102e;
            color: white;
        }

        i {
            margin-right: 10px;
        }


    }

    .active3 {
        background: #c8102e;
        color: #e18890;
        font-size: 13px;
        display: flex;
        justify-content: space-between;
    }

    .is_item {
        color: #fff !important;

    }

    .active2 {
        color: #fff !important;
    }
}

.content {
    flex: 1;
    margin-left: 20px;
    // min-height: 700px;

    .content-header {
        font-size: 16px;
        padding: 10px 0 0 0;

        .tag_list {
            display: flex;
            margin-top: 15px;

            .tag_item {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 98px;
                height: 40px;
                color: #999999;
                background-color: #DCDCDC;
                border-radius: 12px 12px 0 0;
                cursor: pointer;

            }

            .select {
                background-color: #c31424;
                color: #fff;
            }
        }
    }

    .boxc {
        display: flex;
        margin-top: 20px;
    }

    .right {
        border: 2px solid #EDEEF1;
        padding-bottom: 20px;
        border-radius: 0 0 10px 10px;
    }



    .pagination {
        margin-top: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .page {
            padding: 5px 10px;
            margin: 0 5px;
            cursor: pointer;

            &.active {
                background: #c8102e;
                color: white;
                border-radius: 2px;
            }
        }
    }
}

.status {
    display: flex;
    flex-direction: column;
    font-size: 18px;
    color: #333333;

    .status_box {
        display: flex;
        align-items: center;
    }

    .status_test {
        display: flex;
        font-size: 16px;
        color: #52A847;
        width: 168px;
        // height: 36px;
        padding: 10px 20px;
        background-color: #F3FDF1;
        box-sizing: border-box;
    }
}


.title {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    height: 50px;

    &::after {
        position: absolute;
        left: 0;
        bottom: -2px;
        display: block;
        content: '';
        width: 280px;
        height: 2px;
        background-color: #C31424;
    }

    .left_text {
        position: absolute;
        left: 0;
        font-size: 18px;
        color: #333;
        cursor: pointer;
    }

    .center {
        font-size: 20px;
        color: #333333;
    }
}

.footerContent {
    width: 100%;
    padding: 3px 20px;
    box-sizing: border-box;
    border: 2px solid #EDEEF1;
    border-radius: 0 0 10px 10px;
    font-size: 16px;
    color: #333333;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;

    ::v-deep .el-form-item {
        margin-bottom: 3px !important;
    }

    ::v-deep .el-form-item:last-child {
        margin-bottom: 0px !important;
    }

    .handle_image_l {
        margin-right: 15px;
    }

    .input_style {
        width: 60%;
    }

    .year_styl {
        display: flex;
    }

    .form_item {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px !important;

        .lable {
            font-size: 14px;
            color: #606266;
            display: flex;
        }

        .direction {
            display: flex;
            flex-direction: column;

            .url_text {
                font-size: 16px;
                color: #0256FF;
            }


        }

        .btn {
            display: flex;
            align-items: flex-end;
            margin-left: 15px;
        }

        .footer_text {
            font-size: 12px;
            color: #999999;
        }
    }

    .el_item:last-child {
        margin-bottom: 0px;
    }

    .upload_container {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;

        .yu_lan {
            border: 2px solid #666666;
            width: 38px;
            height: 25px;
            font-size: 12px;
            color: #666666;
            text-align: center;
            line-height: 25px;
            margin-left: 15px;
        }
    }
}



.header_box {
    height: 65px;
    background-color: #fcf3f4;
    display: flex;
    align-items: center;
    justify-content: space-around;

    .money_item {
        font-size: 16px;
    }
}

.agreement-text {
    color: #666;
    font-size: 14px;
}

.dialog_content {
    .title_ {
        font-size: 16px;
        text-align: center;
        margin-bottom: 20px;
    }

    .money_box {
        display: flex;
        justify-content: space-around;
        margin: 30px 0;

        .item_price {
            display: flex;
            align-items: center;
            font-size: 15px;
        }
    }
}

.upload-tips {
    font-size: 13px;
}

.xiao_shou {
    cursor: pointer;

}

.container_ {
    width: 49.5%;
}

.container_B {
    display: flex;
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
}
</style>